import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Metairie, LA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Metairie can take 2–6 months, especially during busy travel seasons. For Lakeside professionals, Elmwood business district executives, and Jefferson Parish families planning international trips, that timeline is simply not viable.",
  },
  {
    q: "Can Metairie business travelers get an expedited passport quickly?",
    a: "Absolutely. Metairie energy industry consultants, healthcare executives, and legal professionals are some of our most common client types. International meetings, conferences, and client visits often materialize with short notice. We regularly process expedited renewals and new applications for business travelers on compressed timelines. Contact us as soon as your travel is confirmed.",
  },
  {
    q: "What if my passport expires before a family cruise from New Orleans?",
    a: "This happens more often than you would think — especially among Metairie families with busy school and activity schedules. Cruise passengers departing from the Port of New Orleans often discover expired passports days before sailing. Most Caribbean itineraries require your passport to be valid for at least six months beyond your return date. Standard mail-in renewal through a Metairie post office typically takes 2–6 months — far too long for an upcoming sailing.",
  },
  {
    q: "Can families in Kenner and River Ridge get expedited passports?",
    a: "Yes. Families throughout Jefferson Parish have the same access to our expedited services as Metairie residents. Since we operate remotely, your physical location in the parish does not affect processing speed. Ship your documents overnight from anywhere in the Metairie-Kenner area, and we handle the rest. Most clients in Jefferson Parish receive their passports within 2–9 business days.",
  },
  {
    q: "How quickly can travelers in Elmwood and Old Jefferson receive an expedited passport?",
    a: "Elmwood, Old Jefferson, and surrounding neighborhoods have the same access to our expedited services as Metairie residents. Since we operate remotely, your physical location in Jefferson Parish does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients in the Metairie area receive their passports within 2–9 business days.",
  },
  {
    q: "Can retirees in Metairie expedite a passport renewal for European travel?",
    a: "Yes — Metairie retirees planning trips to Europe, Latin America, or Asia are well within our service area. Whether you are visiting grandchildren abroad, taking a Mediterranean cruise, or joining a group tour through Italy or France, we make the renewal process straightforward. You do not need to drive to New Orleans for a passport agency appointment. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Metairie travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Metairie, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in Jefferson Parish.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function MetairieFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Metairie and Jefferson Parish travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}